export default {"src":"/_next/static/image/public/images/flags/flag_291.a15cbd37c93d524e1a03bd25c5e42ff8.svg","height":16,"width":25};